import React, { useState } from "react";
import { Button } from "@mui/material";
import SignCreator from "./SignCreator";

const CreateSignButton = ({
  event,
  eventUrl,
  photoLimit = 15,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
    <Button
  fullWidth
  variant="contained"
  onClick={() => setOpen(true)}
  sx={{
    mt: 1.5,
    py: 1.4,
    borderRadius: "999px",
    bgcolor: "#000",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",

    "&:hover": {
      bgcolor: "#111",
      boxShadow: "none",
    },

    "&:active": {
      transform: "scale(0.985)",
    },
  }}
>
  Create a Sign
</Button>

      {open && (
        <SignCreator
          open={open}
          onClose={() => setOpen(false)}
          event={event}
          eventUrl={eventUrl}
          photoLimit={photoLimit}
        />
      )}
    </>
  );
};

export default CreateSignButton;